import { render, staticRenderFns } from "./TertiaryButton.vue?vue&type=template&id=d64a2254&scoped=true&"
import script from "./TertiaryButton.vue?vue&type=script&lang=ts&"
export * from "./TertiaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./TertiaryButton.vue?vue&type=style&index=0&id=d64a2254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64a2254",
  null
  
)

export default component.exports